import { Plus as PlusIcon } from 'iconoir-react'
import { useState, type Ref } from 'react'
import { ContactsSearch } from '../shared/ContactsSearch'
import type { ContactJson } from 'app/types/entities'
import { useContactStore } from 'app/stores/StoreContext'
import { useWorkspace } from 'app/utils'

export function ContactsPopover(props: {
  pipelineId: string
  hideButton?: boolean
  contactHandler: (contactId: string) => void
  selectedContact: (contact: ContactJson) => void
  ref?: Ref<HTMLDivElement>
}) {
  const { hideButton, pipelineId, selectedContact, ref } = props
  const workspace = useWorkspace()
  const contactStore = useContactStore()
  const [contacts, setContacts] = useState<ContactJson[]>([])
  const [contactsLoaded, setContactsLoaded] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const getContacts = async (search?: string) => {
    setIsLoading(true)
    let searchStr = workspace ? `workspaceId:${workspace.id}` : ``
    if (search) {
      searchStr = `${searchStr} AND !pipelines.id:"${pipelineId}" AND name:*${search}*`
    } else {
      searchStr = `${searchStr} AND !pipelines.id:"${pipelineId}"`
    }
    const result = await contactStore.fetchList({ search: searchStr })
    const hits = (result.data as any)?.contacts?.hits as ContactJson[] | undefined
    if (hits?.length) {
      setContacts(hits as unknown as ContactJson[])
    }
    if (!contactsLoaded) setContactsLoaded(true)
    setIsLoading(false)
  }
  return (
    <div className={hideButton ? `relative -top-[18px] bg-transparent` : `cursor-pointer`}>
      <ContactsSearch
        buttonChild={
          <div
            ref={ref}
            className={`${hideButton ? `hidden` : `flex`} w-full space-x-2`}
            onClick={async () => getContacts()}
          >
            <PlusIcon className="h-4 w-4 text-minimal" />
            <span className="text-heading-xs text-minimal">Add new</span>
          </div>
        }
        contacts={contacts}
        isLoading={isLoading}
        onSearch={getContacts}
        onSelect={(contact) => selectedContact(contact as ContactJson)}
      />
    </div>
  )
}
